import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export function CenteredSpinner({
  ariaLabel
}) {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "100dvh",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      "aria-label": ariaLabel
    })
  });
}